import { ACTIONS } from '../constants/dashboard';

const INITIAL_STATE = {
  data: null,
  error: null,
  loading: false,
};

export const dashboard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.DASHBOARD_FETCH_START:
      return {
        ...state,
        data: null,
        error: null,
        loading: true,
      };
    case ACTIONS.DASHBOARD_FETCH_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
        loading: false,
      };
    case ACTIONS.DASHBOARD_FETCH_FAILURE:
      return {
        ...state,
        data: null,
        error: action.payload,
        loading: false,
      };
    case ACTIONS.RESET_DASHBOARD_FETCH:
      return {
        ...state,
        data: null,
        error: null,
        loading: false,
      };
    default:
      return state;
  }
};
